import { MobileDetector } from './';
export class DisplayManager {
    #width = 0;
    #height = 0;
    #ratio = 0;
    PORTRAIT = 'portrait-primary';
    LANDSCAPE = 'landscape-primary';
    setUp(inIframe = false) {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        if (!MobileDetector.isMobile()) {
            this.width = 1280;
            this.height = 720;
        }
        else if (inIframe) {
            const coef = MobileDetector.isAndroid() ? 0.5 : 0.55;
            this.width = Math.round(this.width / coef);
            this.height = Math.round(this.height / coef);
        }
        this.ratio = this.width / this.height;
        const liveLayoutElement = document.getElementById('live-layout');
        if (liveLayoutElement) {
            liveLayoutElement.classList.add(MobileDetector.isMobile() ? 'mobile' : 'web');
        }
    }
    get width() {
        return this.#width;
    }
    set width(width) {
        this.#width = width;
    }
    get height() {
        return this.#height;
    }
    set height(height) {
        this.#height = height;
    }
    get ratio() {
        return this.#ratio;
    }
    set ratio(ratio) {
        this.#ratio = ratio;
    }
    getScreenOrientation() {
        let orientation;
        if (window.screen) {
            orientation = (window.screen.mozOrientation || window.screen.msOrientation ||
                window.screen.orientation);
        }
        if (orientation && typeof orientation.type === 'string') {
            return orientation.type;
        }
        if (typeof orientation === 'string') {
            return orientation;
        }
        if (typeof window.orientation === 'number') {
            if ((window.orientation === 0 || window.orientation === 180)) {
                return this.PORTRAIT;
            }
            return this.LANDSCAPE;
        }
        if (window.matchMedia) {
            if (window.matchMedia('(orientation: portrait)').matches) {
                return this.PORTRAIT;
            }
            if (window.matchMedia('(orientation: landscape)').matches) {
                return this.LANDSCAPE;
            }
        }
        if ((window.innerHeight > window.innerWidth)) {
            return this.PORTRAIT;
        }
        return this.LANDSCAPE;
    }
}
export const displayManager = new DisplayManager();
//# sourceMappingURL=DisplayManager.js.map